// pages/+Loading.jsx
import React from "react";
import { LoadingOverlay } from "@mantine/core";

export default {
  layout: LoadingLayout,
  component: LoadingComponent,
};

function LoadingLayout() {
  // Applies on a component-level
  return (
    <LoadingOverlay
      visible={true}
      zIndex={1000}
      overlayProps={{ blur: 2 }}
      loaderProps={{ type: "bars", color: "blue", size: "lg" }}
    />
  );
}

function LoadingComponent() {
  // Applies on a component-level
  return (
    <LoadingOverlay
      visible={true}
      zIndex={1000}
      overlayProps={{ blur: 2 }}
      loaderProps={{ type: "bars", color: "blue", size: "lg" }}
    />
  );
}
